define('toolkit/b-controls/b-controls',
	[
		'jquery',
		'toolkit/b-toolkit/b-toolkit',
		'toolkit/btn/btn'
	], function ($, toolkit) {
		'use strict';

		return toolkit.create( 'b-controls', {

			init: function () {
				this.next = new toolkit.btn({
					$el: this.$('.js-next')
				});
			},

			disableNext: function () {
				this.next.toggleMod('disabled', true);
			},

            enableNext: function () {
                this.next.toggleMod('disabled', false);
            }

		});
	});
